import { Component, ViewEncapsulation, input, output } from '@angular/core';
import { FooterComponent, type FooterLink } from '@purolator/ui-kit-angular';

/** Option shown in the footer language selector, matching the kit's `languages` shape. */
export interface FooterLanguageOption {
  label: string;
  value: string;
}

/**
 * Application footer with the kit's native language selector, legal links, and copyright.
 */
@Component({
  selector: 'app-shell-footer',
  imports: [FooterComponent],
  templateUrl: './shell-footer.html',
  styleUrl: './shell-footer.scss',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-shell__footer' },
})
export class ShellFooter {
  readonly legalLinks = input.required<FooterLink[]>();
  readonly copyrightText = input.required<string>();
  readonly language = input.required<string>();
  readonly languages = input.required<FooterLanguageOption[]>();
  readonly languageChange = output<string>();
}
